import React, { Component } from 'react';
import Helmet from "react-helmet";
import { lang } from '../../../il8n/lang';
import { connect } from 'react-redux';
import Caro from '../../Carousels/Caro/Caro';
import Collectioncaro from '../../Collectioncaro/Collectioncaro';
import Productcaro from '../../Productcaro/Productcaro';
import Variants from '../../Variants/Variants'
import GeneralModal from '../../GeneralModal/GeneralModal';
import VideoPlayer from '../../VideoPlayer/VideoPlayer';
import ReactGA from 'react-ga';




import { toggleInterstitial } from '../../../Actions/Index';
import './Home.css';
import { cdnBase, breakSmall } from '../../../const';
import _ from 'lodash';


/**
 * Home
 * @constructor
 */

class Home extends Component {
  constructor(props){
    super(props);
    this.state = {
      modalOpen: false,
    };

    this.toggleModal = this.toggleModal.bind(this);



  }
  componentDidMount(){
    this.props.dispatch(toggleInterstitial(false, '', ''))
  }

  toggleModal(vid){
    this.setState(state => ({
      modalOpen: !state.modalOpen,
      currentvid: vid
    }));
  }
  componentWillMount() {

    window.addEventListener('resize', this.onResize, false);
    this.throttledResize = _.throttle(this.throttledResize.bind(this), 500);
    this.onResize();
  }

   /**
  }
  * Tied to the resize event on window
  */
  onResize = (e) => {
    this.throttledResize(e);
  }
  /**
  * Throttled resize function, handles resetting slidesToShow count
  */
  throttledResize = (e) => {
    // console.log('flsdjhl')
    this.setState({
      mobileView: window.innerWidth < breakSmall ? true : false
    });

  }

  render() {
    let {gaToggle} = this.props;
    return (
      <div>
        <Helmet title={ lang.home.title + lang.helmet.siteTitle } />
        <GeneralModal open={this.state.modalOpen} toggleModal={this.toggleModal}>
          <VideoPlayer
            type={'default'}
            activeVid={this.state.currentvid}
            warn={lang.warnings.enableIframes}
            autoPlay={true}
            loop = {false}

          />
        </GeneralModal>
        <div className="home">
          <Caro respSlidesToShow={1} slidesToShow={1} frameOverflow={false} insertClass={'caro--homebanner'}>
            {lang.home.slides.map((slide, index) => {
              let img =  this.state.mobileView ? slide.mobileImg : slide.img;
              return(
                <div className='caro__item homepage__hero' key={slide.heading+index}>
                  <div className='caro__img'>
                    <img  
                      alt={slide.heading} 
                      src={img} 
                    />
                  </div>
                  
                  <div className={`caro__desc mod-${slide.class}`}>
                  
                      <div className={`custombanner banner-${index}`}>
                        <h1>{slide.heading}</h1>
                        <p>{slide.subheading}</p>
                        {slide.cta_type === "external" ?
                        <a href={`${slide.cta_link}`} target="_blank"><button>{slide.cta}</button></a>
                        :
                        <a href={`/${lang.getLanguage()}${slide.cta_link}`} ><button>{slide.cta}</button></a>
                        }
                        {/* {lang.home.slides[index].cta_link && (
                          <a href={slide.cta_link} ><button>{lang.learnmore}</button></a>
                        )} */}
                      </div>
                  </div>
                </div>
              )
              })
            }
            
          </Caro>

        {/*WHERE TO BUY************************************************************/}
        {lang.home.sections.retailers && (
            <div className='section retailers section test' id="wheretobuy">
              <div className="flex-container">
                <div className="home-header">
                  <h1>{lang.home.whereToBuy} </h1>
                </div>
                <div className='retailers-list flex-row flex-row--align-h-center'>
                  {lang.home.sections.retailers.retailers.map((retailer, index) => (
                    <div className='retailer' key={`retailers___${index}`}>
                      <a  target='_blank' rel='noopener noreferrer' onClick={() => {
                        if(retailer.href !== ''){
                          this.props.dispatch(toggleInterstitial(true, retailer.href))
                        }
                      }}>
                        <img className="retailer-img"  id={`${retailer.id}`} src={retailer.img} alt={retailer.name} />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/*PRODUCT CAROUSEL************************************************************/}
          {lang.home.sections.popular && (
            <div className="section popular" style={{backgroundImage : `url('${cdnBase}Graphics/PopularGames-BG-Desktop.jpg')`}}>
              <div className="section__bg">
                <div className="dice3">
                  <img alt="dice" src={`${cdnBase}Graphics/Dice-3.png`}></img>
                </div>
                
                
              </div>
              <div className="flex-container wrap section__fg">
                  <div className="home-header">
                    <h1>{lang.home.sections.popular.header} </h1>
                  </div>
                <Productcaro/>
              </div>
              
            </div>
          )}

          {/*VIDEO CAROUSEL************************************************************/}

          {lang.home.sections.videos.length && (
            <div className="section videosCTA">
              <div className="section__bg">
              </div>
              <div className="section__fg">
                <div className="scrabbleY">                
                  <img alt="scrabble-tile" src={`${cdnBase}Graphics/Letter-Tile-Y.png`}></img>
                </div>
                <div className="scrabbleF">                
                  <img alt="scrabble tile" src={`${cdnBase}Graphics/Letter-Tile-F.png`}></img>
                </div>
                
                <Caro respSlidesToShow={1} slidesToShow={1} frameOverflow={false} insertClass={`caro--videosCTA`}>
                  {lang.home.sections.videos.slides.map((slide, index) => (
                    <div className='caro__item' key={slide.heading+index}>
                      <img className='caro__img' src={slide.img} alt={slide.heading} srcSet={`${slide.img} 1x, ${slide.img2x} 2x`} />
                      <div className='caro__desc '>
                        <div className=" flex-container flex-row mod-centered flex-row--align-v-column flex-row--align-v-center">
                          <div className="videotileIcon" onClick={()=>this.toggleModal(slide.cta_link)}>
                            <img src={`${cdnBase}Icons/HowToVideo-Icon.svg`}></img>
                          </div>
                          <h2 className="video-header">{slide.heading}</h2>
                          <p>{slide.subheading}</p>

                        </div>
                        
                      </div>
                    </div>
                  ))}
                </Caro>
              </div>
              
            </div>
            

          )}
          {/*TEST 2-Block PROMO SECTION************************************************************/}
          {lang.home.sections.doubleblock && (
            <div className="section" >
              <div className="section__bg doubleblock desktoponly">
                <div className="flex-row">
                  <div className="flex-col-sm-6 doubleblock-support">
                  </div>
                  <div className="flex-col-sm-6 doubleblock-youtube">
                  </div>
                </div>
              </div>
              <div className="section__fg doubleblock">
                <div className="flex-container">
                  <div className="flex-row">
                    <div className="flex-col-sm-6 mod-centered doubleblock-support flex-row--align-v-center ">

                      <div className="doubleblock-img flex-col-sm-6">
                        <img src={lang.home.sections.doubleblock.support.img} alt={lang.home.sections.doubleblock.support.imgalt}></img>
                      </div>
                      <div className="flex-col-sm-6 flex-row--align-v-column flex-row--align-v-center">
                        <h2>{lang.home.sections.doubleblock.support.header}</h2>
                        <p>{lang.home.sections.doubleblock.support.copy}</p>

                        <a href={lang.home.sections.doubleblock.support.cta_link}>
                          <button>{lang.home.sections.doubleblock.support.cta_text}</button>
                        </a>
                      </div>

                    </div>
                    <div className="flex-col-sm-6 mod-centered doubleblock-youtube flex-row--align-v-center">
                        
                      <div className="flex-col-sm-6 flex-row--align-v-column flex-row--align-v-center">
                        <h2>{lang.home.sections.doubleblock.youtube.header}</h2>
                        <p>{lang.home.sections.doubleblock.youtube.copy}</p>
                        
                        <a href={lang.home.sections.doubleblock.youtube.cta_link}>
                          <button>{lang.home.sections.doubleblock.youtube.cta_text}</button>
                        </a>
                      </div>

                      <div className="doubleblock-img flex-col-sm-9">
                        <img src={lang.home.sections.doubleblock.youtube.img} alt={lang.home.sections.doubleblock.youtube.imgalt}></img>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          )}

          {/*WHERE TO BUY************************************************************/}
          {lang.home.sections.retailers && (
            <div className='section retailers section' >
              <div className="flex-container">
                <div className="home-header">
                  <h1>{lang.home.whereToBuy} </h1>
                </div>
                <div className='retailers-list flex-row flex-row--align-h-center'>
                  {lang.home.sections.retailers.retailers.map((retailer, index) => (
                    <div className='retailer' key={`retailers___${index}`}>
                      <a target='_blank' rel='noopener noreferrer' onClick={() => {
                        if(retailer.href !== ''){
                          this.props.dispatch(toggleInterstitial(true, retailer.href))
                        }
                      }}>
                        <img className="retailer-img"  id={`${retailer.id}`} src={retailer.img} alt={retailer.name} />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
              <div className="dice6">
                <img alt="dice" src={`${cdnBase}Graphics/Dice-6.png`}></img>
              </div>
            </div>
          )}

          
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { 
    lang: state.lang,
    gaToggle: state.gaToggle

  };
}

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/Pages/Home/Home.js